<template lang="pug" src="./menu-desktop.pug"></template>

<script>
import Icon from 'components/icon/icon'

export default {
  computed: {
    props () {
      return this.$router.options.routes
    },
    items () {
      return this.$store.state
    }
  },
  data () {
    return {
      a: false,
      b: false,
      c: false,
      active: false,
      loaded: false,
      last: 0
    }
  },
  async mounted () {
    document.addEventListener('keydown', e => e.key === 'Escape' ? this.$store.dispatch('MENU_ACTIVE', false) : '')
  },
  watch: {
    '$store.state.menuActive': function (e) {
      setTimeout(e => { this.active !== false ? this.active = false : this.active = 0 }, 200)
      setTimeout(e => { this.a ? this.a = false : this.a = true }, 200)
      setTimeout(e => { this.b ? this.b = false : this.b = true }, 400)
      setTimeout(e => { this.c ? this.c = false : this.c = true }, 600)
    }
  },
  methods: {
    change (i, l) {
      this.active = i
    },
    close () {
      this.active = 0
      this.loaded = false
      this.$store.dispatch('MENU_ACTIVE', false)
    }
  },
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// src/components/menu/menu-desktop/menu-desktop.vue